import React from "react";
import styled from "styled-components";

const Overlay = styled.div`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: #00000070;
`;

const Container = styled.div`
  width: 25%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: white;
  padding: 2%;
  border-radius: 2rem;
`;

const LoadingImage = styled.img`
  width: 100%;
  height: 100%;
`;

export default (props) => {
  return (
    <Overlay>
      <Container>
        <LoadingImage src="assets/llama-animated.gif" />
      </Container>
    </Overlay>
  );
};
